import React from "react";
import CartSummarySkeleton from "./CartSummarySkeleton";

const OrderSkeleton = () => {
  return (
    <div
      style={{
        backgroundColor: "#f0f0f0",
        minHeight: "100vh",
        padding: "20px",
        marginBottom: "50px",
      }}
    >
      {/* Title Skeleton */}
      <div
        style={{
          height: "36px",
          width: "200px",
          backgroundColor: "rgba(0,0,0,0.1)",
          borderRadius: "8px",
          marginBottom: "40px",
          marginTop: "20px",
        }}
      />

      {/* Product Cards Skeleton */}
      <div style={{ marginBottom: "40px" }}>
        {[1, 2, 3, 4, 5].map((index) => (
          <ProductCardSkeleton key={index} />
        ))}
      </div>

      {/* Cart Summary Skeleton */}
      <CartSummarySkeleton />

      {/* Place Order Button Skeleton */}
      <div
        style={{
          height: "50px",
          backgroundColor: "rgba(0,0,0,0.1)",
          borderRadius: "10px",
          marginTop: "10px",
        }}
      />
    </div>
  );
};

const ProductCardSkeleton = () => {
  return (
    <div
      style={{
        display: "flex",
        backgroundColor: "white",
        borderRadius: "20px",
        padding: "10px",
        marginBottom: "8px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
      }}
    >
      {/* Image Skeleton */}
      <div
        style={{
          width: "120px",
          height: "120px",
          backgroundColor: "rgba(0,0,0,0.1)",
          borderRadius: "10px",
          marginRight: "10px",
        }}
      />

      {/* Content Skeleton */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {/* Name and Price Skeleton */}
        <div>
          <div
            style={{
              height: "20px",
              width: "80%",
              backgroundColor: "rgba(0,0,0,0.1)",
              borderRadius: "4px",
              marginBottom: "8px",
            }}
          />
          <div
            style={{
              height: "18px",
              width: "60px",
              backgroundColor: "rgba(76, 175, 80, 0.3)",
              borderRadius: "4px",
            }}
          />
        </div>

        {/* Quantity Controls Skeleton */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "10px",
          }}
        >
          <div
            style={{
              width: "120px",
              height: "40px",
              backgroundColor: "rgba(76, 175, 80, 0.3)",
              borderRadius: "25px",
            }}
          />
        </div>
      </div>
    </div>
  );
};

<CartSummarySkeleton />;

export default OrderSkeleton;
